import apiFetch from '../apiFetch'

export default function (token, presentsId) {
  return apiFetch({ endPoint: `PresentType/${presentsId}`, method: 'GET', body: null, token: token })
}
